<!-- eslint-disable max-lines -->
<template>
    <paper v-loading="btnloading" class="mip-iframe" >
        <div class="top-box">
            <!-- 按钮区域 -->
            <div class="detail-toolBar">
                <lots-button type="primary"
                    :disabled="detailDataLocal.mipStatus ? [2, 3, 4, 7].includes(+detailDataLocal.mipStatus) : false"
                    :loading="saveLoading" @click="handleSave">保存
                </lots-button>
                <el-tooltip class="item-flow-right" effect="dark" content="刷新" placement="bottom">
                    <lots-button size="mini" icon="el-icon-refresh" class="refresh" @click="refleshPage()"
                        :loading="detailLoading">
                    </lots-button>
                </el-tooltip>
            </div>
        </div>
        <div class="strategic-cooperation-introduce-apply" v-loading="detailLoading">
            <!-- 表单区域 -->
            <collapse-infos ref="upholdHealder" :detailData="detailDataLocal" :collapse="COLLAPSE"
                :activeCollapses="activeCollapses" @change="handleInfosChange">
                <!-- 折叠筐标题插槽 -->
                <template v-slot:collapse-title-append="{ collapseItem }">
                    <span>{{ collapseItem.title }}</span>
                </template>
                <!-- 表单字段插槽 -->
                <template v-slot:collapse-append="{ form, itemSetting, rIndex, collapseItem, dictData }">
                    <span v-if="itemSetting.prop === 'relatedFiles'">
                        <lots-upload-button :text="'上传附件'" :bucket="'annto-lcrm'"
                            :disabled="['3', '4', '7'].includes(detailDataLocal.mipStatus + '')"
                            @callback="(data) => { upLoadData(form, itemSetting, data); }">
                        </lots-upload-button>
                        <div class="file-infos">
                            <template v-if="form[itemSetting.prop]
                                && form[itemSetting.prop].length">
                                <div class="file-list" v-for="(item, index) in form[itemSetting.prop]"
                                    :key="index + item.fileName">
                                    <div class="file-name upload" :title="item.fileName">
                                        {{ `${index + 1}. ` }}
                                        <a :href="item.fileUrl" target="_blank">{{ item.fileName }}</a>
                                    </div>
                                    <div class="delete-btn">
                                        <el-button type="text" plain @click="handlePreview(item)">
                                            预览
                                        </el-button>
                                        <el-button type="text" plain>
                                            <a :href="item.fileUrl" target="_blank">下载</a>
                                        </el-button>
                                        <el-button type="text"
                                            :disabled="['3', '4', '7'].includes(detailDataLocal.mipStatus + '')" plain
                                            @click="handleDeleteFile(form, itemSetting, index)">删除</el-button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </span>

                    <div v-else-if="itemSetting.prop === 'customerWhiteList'">
                        <div class="resistr-add">
                            <lots-button type="primary" :disabled="!whiteRulesShow['addBtn']"
                                @click="changeData">新建记录</lots-button>
                            <lotsButton icon="el-icon-delete" type="primary" size="mini" title="删除"
                                :disabled="!whiteRulesShow['addBtn'] || !(detailDataLocal.customerWhiteList && detailDataLocal.customerWhiteList.length)" @click="handleDelete">删除
                            </lotsButton>
                        </div>
                        <edit-table-box ref="editTableBox" :selection="true" :control="whiteRulesShow['addBtn']"
                            :height="280" :allowRowClick="false" :tableData="detailDataLocal.customerWhiteList"
                            :columns="newTableConfig.columns" :actions="newTableConfig.actions"
                            @selection-change="handleSelectedRow" @btn-event="actionClick">
                        </edit-table-box>
                    </div>
                    <span v-else-if="!itemSetting.optionsKey" class="custom-span" :title="form[itemSetting.prop]">
                        {{ (form[itemSetting.prop] || form[itemSetting.prop] === 0) ? form[itemSetting.prop] : '--' }}
                    </span>

                </template>
            </collapse-infos>

            <!-- iflow区域 -->
            <el-collapse v-if="detailDataLocal.mipId" class="contract-collapse detail-more-collapse" value="mipInfo">
                <el-collapse-item title="流程信息" name="mipInfo">
                    <div class="header-operation">
                        <lots-button size="mini" type="primary" v-if="!['7'].includes(detailDataLocal.mipStatus + '')"
                            @click="submitMip" :loading="btnloading">
                            mip提交
                        </lots-button>
                    </div>
                    <iframe class="ifr" :src="mipUrl" v-if="!btnloading" />
                </el-collapse-item>
            </el-collapse>
        </div>

        <!-- <advance-multi-dialog
            ref="advanceMultiDialog"
            @confirm="registractionSaveSure">
        </advance-multi-dialog> -->
        <tableMutiAdvanceDialog ref="advanceDialogRef" @confirm="(data, config) => addRegistractionSure(data, config)">
        </tableMutiAdvanceDialog>
    </paper>
</template>

<script>
import { ref, watch, computed, getCurrentInstance, onMounted, onActivated } from '@vue/composition-api';
import paper from '@/components/core/Paper.vue';
import lotsButton from '@/components/lots/lotsButton';
import CollapseInfos from '@/modules/mdm/views/contractModules/components/collapseInfos/CollapseInfos.vue';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
import editTableBox from '@/components/lots/editTableBox/Index';
import { saveCustomerWhitelistFlow, getCustomerWhitelistFlow } from '@/modules/mdm/api/customer/customerManage.js';
import { getNodesAndOperationApi } from '@mdm/utils/flowUtils.js';
import { approveProcess } from '@/modules/mdm/api/contractManage/detailMainApi.js';
import { Message, MessageBox } from 'element-ui';
import store from '@/store/index';
import utils from '@/components/utils/common.js';
import { collapse } from './collapseInfosConfig.js';
import _ from 'lodash';
import configurl from '@/config/user.env';
import { tableConfig } from './config.js';
import { verifyWhiteCustomerFunc } from '../config.js';
// import advanceMultiDialog from '@/components/lots/otpAdvanceMultiDialog';
import tableMutiAdvanceDialog from '@/modules/mdm/views/contractModules/components/tableMutiAdvanceDialog/Index';
import { filePreview } from '@/utils/filePreview.js';
const { MAGIC_NUMBER } = utils;
export default {
    name: 'whiteListFlow',
    components: {
        paper,
        lotsButton,
        CollapseInfos,
        lotsUploadButton,
        editTableBox,
        // advanceMultiDialog
        tableMutiAdvanceDialog
    },
    props: {
        detailPageState: {
            type: String,
            default() {
                return '';
            }
        },
        detailData: {
            type: Object,
            return: () => { }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const config = _.cloneDeep(collapse);
        const newTableConfig = ref(_.cloneDeep(tableConfig));
        const detailLoading = ref(false);
        const btnloading = ref(false);
        const disabledFlag = ref(false);
        const detailDataLocal = ref({
            mipId: '',
            relatedFiles: [], // 相关附件
            customerWhiteList: []
        });

        // * 1：草稿；
        // * 2：待审批；
        // * 3：审批中；
        // * 4：审批通过；
        // * 5：审批驳回；
        // * 6：撤回；
        // * 7：作废
        const whiteRulesShow = computed(() => {
            const { id, mipId } = detailDataLocal.value;
            return {
                'addBtn': !id || !mipId || ['1', '5', '6'].includes(detailDataLocal.value.mipStatus?.toString())
            };
        });
        // const authority = store.getters.authority;
        // eslint-disable-next-line max-len
        const activeCollapses = ref(['whiteInfo']);
        const mipUrl = ref('');
        const COLLAPSE = computed(() => { // 配置项动态计算
            const { mipStatus } = detailDataLocal.value;
            config.forEach((v, i) => {
                v.formList.forEach((v2, i2) => {
                    if (v2.prop === 'whitelistRemark') {
                        /**
                         * 数据字典：RENEWAL_AUDIT_STATUS
                         * 1：草稿；
                         * 2：待审批；
                         * 3：审批中；
                         * 4：审批通过；
                         * 5：审批驳回；
                         * 6：撤回；
                         * 7：作废
                        */
                        // eslint-disable-next-line max-nested-callbacks
                        v2.disabled = ['3', '4'].includes(mipStatus?.toString()); // 审批中、审批通过、
                    }
                });
            });
            return config;
        });
        const tableHeight = computed(() => {
            function getHeight(prop) {
                const length = detailDataLocal.value[prop].length;
                return length ? length * MAGIC_NUMBER.THIRTY_SIX + MAGIC_NUMBER.FOURTY_ONE + 1 + 'px' : MAGIC_NUMBER.FIFTY_ONE + 7 + MAGIC_NUMBER.FIFTY + 'px';
            }
            return getHeight;
        });

        const newMip = ref(false);
        const refleshPage = () => {
            if (isHandleEdit.value) {
                MessageBox.confirm(`你当可能存在编辑未保存的数据，刷新页面将覆盖编辑的数据，确认继续刷新？`, `注意：`, {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _initData();
                });
            } else {
                _initData();
            }
        };
        // 处理详情返回数据格式
        const formatData = (data) => {
            const newData = _.cloneDeep(data);
            !newData.relatedFiles && (newData.relatedFiles = []);
            return newData;
        };
        const { userName, userCode } = store.getters.user;
        // eslint-disable-next-line complexity
        const _initData = async () => {
            const { customerWhitelistCode } = ctx.$route.query;
            detailLoading.value = true;
            if (customerWhitelistCode) {
                await getgetCustomerWhitelistInfo();
            }
            detailLoading.value = false;
            handleInfosChange({ form: formatData(detailDataLocal.value) });
        };
        const currentAuth = ref(false);
        const isHandleEdit = ref(false);
        const handleInfosChange = async (formObjData = {}) => { // 表单组件编辑回调，更新本地数据
            const { itemSetting } = formObjData;
            // 监控表单是否编辑过
            isHandleEdit.value = Boolean(itemSetting);
            if (!itemSetting) { // 页面初始化、刷新时走：
                if (detailDataLocal.value.mipId) {
                    handleCreate(); // 渲染iflow流程
                    currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.mipId, loginName: userCode });
                }
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
            } else { // collapse组件编辑回调时走：
                const { relatedFiles } = detailDataLocal.value;
                // 除了插槽参数以外，其他参数取最新编辑的参数更新(因：插槽的编辑不会触发collapse组件change事件回调，因此change事件回调的插槽的参数是旧数据不能取)
                detailDataLocal.value = Object.assign(
                    {},
                    detailDataLocal.value,
                    formObjData.form,
                    { relatedFiles } // 保证插槽数据用最新的
                );
            }
            // detailDataLocal.value.mipStatus = '7';
        };

        const handleCreate = () => {
            mipUrl.value = '';
            mipUrl.value = `${configurl.iflowUrl}?fdId=${detailDataLocal.value.mipId}&fdTemplateKey=CRM_customer_whitelist&userCode=${userCode}&userName=${userName}`;
            createMetaNode();
            window.addEventListener('message', messageFunc, false);
            newMip.value && setTimeout(() => {
                const element = document.getElementsByClassName('mip-iframe')[0];
                element.scrollTo(0, MAGIC_NUMBER.TWO_THOUSAND); // 页面滚动到MIP审批位置
                newMip.value = false;
            }, MAGIC_NUMBER.FOUR_HUNDRED);
        };
        const createMetaNode = () => {
            const mipmeta = document.getElementById('mipmeta');
            if (mipmeta) {
                return false;
            }
            const meta = document.createElement('meta');
            meta.httpEquiv = 'Content-Security-Policy';
            meta.content = 'upgrade-insecure-requests';
            meta.id = 'mipmeta';
            document.getElementsByTagName('head')[0].appendChild(meta);
        };
        const timer = 1800;
        // approveProcess 回调提取为独立函数，减少嵌套
        const handleApproveProcess = (params) => {
            return approveProcess(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('提交成功');
                    const times = setTimeout(async () => {
                        getgetCustomerWhitelistInfo();
                        currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.mipId, loginName: userCode });
                        clearTimeout(times);
                    }, timer);
                } else {
                    Message.error(res.msg);
                }
            }).finally(() => {
                btnloading.value = false;
            });
        };
        // 参数准备辅助函数
        const prepareApproveParams = (eventData) => {
            const { customerWhitelistCode, mipId } = detailDataLocal.value;
            const { origin, pathname } = window.location;
            const params = eventData.data || {};
            const { tenantCode } = store.getters.currentTenant;
            params.tenantCode = tenantCode;
            params.currentApplicationCode = 'APP201904230047';
            if (params.formParam) {
                const { processParam } = params;
                let isToOtherPersons = '';
                if (processParam.operationType === 'circulate' && processParam.toOtherPersons) {
                    isToOtherPersons = processParam.toOtherPersons;
                }
                // eslint-disable-next-line max-len
                params.formParam.fdUrl = `${origin}${pathname}#/whiteListFlow?customerWhitelistCode=${customerWhitelistCode}&fdId=${mipId}${isToOtherPersons ? `&isToOtherPersons=${isToOtherPersons}` : ''}`;
            }
            return params;
        };
        // draft_submit分支处理
        const handleDraftSubmit = async (params) => {
            try {
                const saveRes = await handleSave(true);
                if (saveRes && +saveRes.code === 0) {
                    await handleApproveProcess(params);
                } else {
                    btnloading.value = false;
                }
            } catch (e) {
                btnloading.value = false;
            }
        };
        // 主流程调度
        const messageFunc = async (event) => {
            if (currentTime.value !== store.getters.iflowPage.pageTime) return;
            if (!(event.data && event.data.data && event.data.success)) return;
            btnloading.value = true;
            const params = prepareApproveParams(event.data);
            const processParam = params.processParam || {};
            if (processParam.operationType === 'draft_submit' && isHandleEdit.value) {
                const data = checkSubmit();
                if (!data) {
                    btnloading.value = false;
                    return;
                };
                await handleDraftSubmit(params);
                handleApproveProcess(params);
                return;
            }
            handleApproveProcess(params);
        };
        // eslint-disable-next-line complexity
        const submitMip = async () => {
            if (!detailDataLocal.value.customerWhiteList.length) {
                return Message.warning('至少存在一条客户记录，请核查！');
            }
            const content = window;
            content.frames && content.frames.length && content.frames[0]
                && content.frames[0].postMessage('mbpm_getApprovalData', mipUrl.value);
            content.frames && content.frames.length && content.frames[1]
                && content.frames[1].postMessage('mbpm_getApprovalData', mipUrl.value); // 解决接入了智能客服后，content.frames[0]被占用了的问题
            currentTime.value = new Date().getTime();
            store.commit('updateIflowPage', { pageTime: currentTime.value });
        };
        const currentTime = ref('');
        const handleEdit = () => {
            // eslint-disable-next-line max-len
            activeCollapses.value = ['basicInfo', 'gaikuangInfo', 'shiyongInfo', 'kehuJingyingInfo', 'kehuZhuanxingInfo', 'kehuHezuoInfo', 'whiteInfo', 'qudaoInfo', 'pinleiInfo', 'dailiInfo', 'relatedFileInfo', 'cankaoFileInfo', 'pingfenInfo'];
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
        };
        const saveLoading = ref(false);
        const checkSubmit = () => {
            const data = _.cloneDeep(setupContext.refs.upholdHealder.onsave());
            // const data = setupContext.refs.upholdHealder.localizeData;
            if (!data) return false;
            const { relatedFiles } = detailDataLocal.value;
            const params = { ...data, relatedFiles };
            if (!params.customerWhiteList.length) {
                Message.warning('至少存在一条客户记录，请核查！');
                return false;
            }
            params.customerIdList = params.customerWhiteList.map(it => Number(it.id));
            delete params.customerWhiteList;
            if ([2, 3, 4, 7].includes(+params.mipStatus)) {
                if ([2, 3, 4, 7].includes(+params.mipStatus)) {
                    Message.warning('流程为待审批/审批中/审批通过/作废时，不允许修改！');
                    return false;
                }
            }
            return data;
        };
        const handleSave = (mipSubmit = false) => {
            const data = checkSubmit();
            if (!data) return;
            const { relatedFiles } = detailDataLocal.value;
            const params = { ...data, relatedFiles };
            params.customerIdList = params.customerWhiteList.map(it => Number(it.id));
            params.whitelistType = ctx.$route.query.flowType || detailDataLocal.value.whitelistType;
            delete params.customerWhiteList;
            saveLoading.value = true;
            return saveCustomerWhitelistFlow(params).then(res => {
                if (+res.code === 0 && res.data) {
                    newMip.value = true;
                    isHandleEdit.value = false;
                    detailDataLocal.value.customerWhitelistCode = res.data;
                    if (mipSubmit === true) return; // 排除点击事件的event
                    Message.success('保存成功');
                    // 更新地址栏url参数
                    const { origin, pathname } = window.location;
                    window.location.assign(`${origin}${pathname}#/whiteListFlow?customerWhitelistCode=${detailDataLocal.value.customerWhitelistCode}`);
                    refleshPage();
                }
            }).finally(() => { saveLoading.value = false; });
        };
        // eslint-disable-next-line complexity
        const upLoadData = async (form, itemSetting, data) => {
            const { prop } = itemSetting;
            form[prop] = form[prop] ? form[prop] : [];
            if (data && +data.code === 0) {
                form[prop].push({ fileName: data.data.name, fileUrl: data.data.downUrl });
                const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
                if (prop === 'relatedFiles') {
                    if (itemSetting.rule[0].required) {
                        const targetRef = formRefs.find(item => item._props.refName === 'whiteForm');
                        targetRef.$refs['whiteForm'].validateField(prop);
                    }
                    detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
                    isHandleEdit.value = true;
                }
            }
        };
        const handleDeleteFile = (form, itemSetting, index) => {
            const { prop } = itemSetting;
            form[prop].splice(index, 1);
            detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
            const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
            if (prop === 'relatedFiles' && itemSetting.rule[0].required) {
                const targetRef = formRefs.find(item => item._props.refName === 'whiteForm');
                targetRef.$refs['whiteForm'].validateField(prop);
            }
            isHandleEdit.value = true;
        };

        const tableKey = ref(false);
        const actionClick = (row, event, index) => {
            /* eslint-disable indent */
            switch (event) {
                case 'del':
                    delAction(row);
                    break;
                default:
                    break;
            }
        };
        const delAction = row => {
            if (detailDataLocal.value.customerWhiteList.length === 1) {
                return Message.warning('至少存在一条客户记录!');
            }
            detailDataLocal.value.customerWhiteList = detailDataLocal.value.customerWhiteList.filter(it => it.id !== row.id);
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value); // 刷新表单子组件
            detailDataLocal.value.customerWhitelistCode && handleSave();
        };
        const submitFlowLoading = ref(false);
        // 白名单转审批类型
        const whiteTypeObj = {
            '0': 'OFF',
            '1': 'ON'
        };
        const getgetCustomerWhitelistInfo = () => {
            const customerWhitelistCode = ctx.$route.query.customerWhitelistCode || detailDataLocal.value.customerWhitelistCode;
            if (!customerWhitelistCode) return;
            btnloading.value = true;
            return getCustomerWhitelistFlow({
                customerWhitelistCode: customerWhitelistCode
            }).then(res => {
                if (res && +res.code === 0) {
                    detailDataLocal.value = res.data;
                    detailDataLocal.value.isWhitelist = detailDataLocal.value.whitelistType;
                    detailDataLocal.value.whitelistType = _.get(whiteTypeObj, detailDataLocal.value.whitelistType, '');
                    detailDataLocal.value.customerWhiteList = detailDataLocal.value.customerList?.map(it => {
                        it.allowEdit = false;
                        it.edit = -3;
                        it.id = it.ebcuId;
                        return it;
                    }) || [];
                    setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
                }
            }).finally(() => {
                btnloading.value = false;
            });
        };
        const handlePreview = (row) => {
            filePreview({
                fileUrl: row.fileUrl,
                fileName: row.fileName
            });
        };

        const addRegistractionSure = async (data = {}, config) => {
            const keys = Object.keys(data);
            const values = keys.map(key => data[key]?.split('|-,') || '');
            // 构建对象数组
            const newRenewalList = values[0].map((_, index) => {
                return keys.reduce((obj, key, i) => {
                    obj[key] = values[i][index];
                    return obj;
                }, {});
            });
            const currentFlowType = ctx.$route.query.flowType || detailDataLocal.value.whitelistType;
            if (!['OFF', 'ON'].includes(currentFlowType)) {
                return Message.warning('请重新选择白名单启用/停用审批类型进行操作!');
            }
            const errorTextList = verifyWhiteCustomerFunc(newRenewalList, currentFlowType);

            if (errorTextList) {
                Message.warning({
                    message: errorTextList,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }
            setupContext.refs.advanceDialogRef.changeVisible(false);

            detailDataLocal.value.customerWhiteList = _.uniqBy(newRenewalList, 'id');
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value); // 刷新表单子组件
            detailDataLocal.value.customerWhitelistCode && handleSave();
        };
        const changeData = () => {
            const _list = detailDataLocal.value.customerWhiteList.map(it => {
                return it;
            });
            const advanceParams = _.cloneDeep(tableConfig.whiteListFlowAdvanceParams);
            setupContext.refs.advanceDialogRef.show(true, advanceParams, { includeFlowCode: detailDataLocal.value.customerWhitelistCode }, '', _list);
        };
        const selectedRows = ref([]);
        const handleSelectedRow = (val) => {
            selectedRows.value = val;
        };
        const handleDelete = () => {
            if (!selectedRows.value.length) {
                Message.warning('请勾选要删除的数据');
                return false;
            };
            if (detailDataLocal.value.customerWhiteList.length - selectedRows.value.length === 0) {
                Message.warning('至少存在一条客户记录!');
                return false;
            }
            detailDataLocal.value.customerWhiteList = _.differenceBy(detailDataLocal.value.customerWhiteList, selectedRows.value, 'id');
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value); // 刷新表单子组件
            detailDataLocal.value.customerWhitelistCode && handleSave();
        };
        onMounted(async () => {

        });
        onActivated(async () => {
            tableKey.value = !tableKey.value;
        });
        // 审批类型转白名单
        const whiteListTypeObj = {
            'OFF': '0',
            'ON': '1'
        };
        watch( // 注意：加了immediate: true的话，watch监听要在放在最后，否则报错涉及的调用方法找不到！
            () => ctx.$route,
            (newVal) => {
                if (newVal.name === 'whiteListFlow') {
                    detailDataLocal.value = {
                        whitelistRemark: '',
                        isWhitelist: _.get(whiteListTypeObj, ctx.$route.query.flowType, '1')
                    };
                    if (ctx.$route.query.customerWhitelistCode) {
                        detailDataLocal.value.customerWhitelistCode = ctx.$route.query.customerWhitelistCode;
                    }
                    const customerWhiteList = store.getters.customerWhiteList.find(it => it.id === ctx.$route.query.uuid)?.list || [];
                    detailDataLocal.value.customerWhiteList = customerWhiteList.map((it, index) => {
                        it.allowEdit = false;
                        it.id = it.ebcuId;
                        return it;
                    });
                    setupContext.root.$nextTick(() => {
                        _initData();
                        setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                    });
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        return {
            config,
            COLLAPSE,
            detailLoading,
            btnloading,
            disabledFlag,
            detailDataLocal,
            mipUrl,
            refleshPage,
            handleInfosChange,
            submitMip,
            handleEdit,
            handleSave,
            upLoadData,
            handleDeleteFile,
            activeCollapses,
            tableHeight,
            tableKey,
            saveLoading,
            actionClick,
            newTableConfig,
            submitFlowLoading,
            handlePreview,
            changeData,
            addRegistractionSure,
            whiteRulesShow,
            handleDelete,
            handleSelectedRow
        };
    }
};
</script>
<style lang="less">
@scrollbarThumbColor: rgba(0, 0, 0, .2);
@scrollbarThumbColorHover: rgba(0, 0, 0, .4);

.mip-iframe {
    // overflow: auto;
    display: flex;
    flex-direction: column;

    .top-box {
        .header-box {
            width: 100%;

            h4 {
                text-align: center;
                font-size: 20px;
                margin: 0;
                color: #606266;
            }

            .header-info-crm {
                width: 100%;
                display: flex;
                font-size: 14px;
                border-bottom: 1px solid #dde0e6;
                margin-bottom: 10px;
                padding-bottom: 5px;

                .tips {
                    flex: 1;
                    // color: red;
                    color: #606266;
                    line-height: 20px;
                }

                .apply-info {
                    width: 200px;
                    line-height: 20px;
                    color: #606266;
                    margin-left: 10px;
                }
            }
        }

        .detail-toolBar {
            .item-flow-right {
                float: right;

                &.refresh {
                    margin-left: 10px;
                }
            }
        }
    }

    .strategic-cooperation-introduce-apply {
        overflow: auto;

        .upload-demo {
            display: inline-block;
        }

        .down-mould-btn {
            margin-left: 5px;
        }

        .upload-tips {
            display: inline-block;
            margin-left: 10px;
            line-height: 28px;
            font-size: 12px;
            color: #606266;
        }

        .file-infos {
            width: 100%;
            padding: 0 10px 0 0;

            .file-list {
                width: 100%;
                padding: 2px 0 2px 4px;
                display: flex;

                // justify-content: space-between;
                .file-name {

                    // flex: 1;
                    &.upload {
                        width: 500px;
                    }

                    padding-right: 5px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: inline-block;
                }

                .view-btn,
                .delete-btn {
                    width: 200px;
                    display: flex;

                    a {
                        text-decoration: none;
                        color: #4285F5;
                    }

                    .el-button {
                        margin-left: 10px;
                    }

                    .el-button:focus,
                    .el-button:hover,
                    .el-button:active,
                    .el-button.is-disabled {
                        outline: none !important;
                        border-color: transparent !important;
                        /* 可选：如果要去除激活时的边框颜色变化 */
                    }
                }
            }
        }

        .el-collapse-item__content {
            padding-bottom: 5px;
        }

        .el-collapse-item__arrow {
            margin: 0 8px 0 5px;
        }

        .el-button.is-disabled.is-plain,
        .el-button.is-disabled.is-plain:focus,
        .el-button.is-disabled.is-plain:hover {
            border-color: #FFF;
        }

        .width-small {
            width: 340px;
        }

        .width-middle {
            width: 500px;
        }

        .width-large {
            width: 1200px;
        }

        .el-form-item--mini.el-form-item,
        .el-form-item--small.el-form-item {
            margin-bottom: 2px;
        }

        .el-col.el-col-23.form-item {
            .el-form-item.el-form-item--mini {
                margin-bottom: 18px;
            }
        }

        .el-collapse-item__header {
            height: 32px;
        }

        .detail-form-collapse {
            padding-right: 10px;
        }

        .score-config-item-box {
            .item-tittle {
                font-size: 14px;
                font-weight: 600;
                color: #606266;
                margin-left: 28px;
            }
        }
        .rating-score-list-box {
            .el-collapse {
                border-bottom: none;

                .el-collapse-item__header {
                    border-bottom: none;
                }

                .el-collapse-item__wrap {
                    border-bottom: none;
                }
            }
        }
    }

    .ifr {
        width: 100%;
        height: 100vh;
        border: none;
    }

    .el-collapse-item__header {
        color: #606266;
        font-size: 14px;
        font-weight: 600;
    }

    .header-operation {
        margin-top: 10px;
    }

    .resistr-add {
        float: right;
        margin-bottom: 8px;
        margin-right: 8px;
    }
}

.no-auth-reg {
    font-size: 16px;
    padding: 20px;
    background: #fff;
    width: 100%;
}

.my-tooltip-box {
    width: 800px;
}
</style>
